'use strict';

var resolveElements = require('../../utils/resolve-elements.cjs');

function setupGesture(elementOrSelector, options) {
    const elements = resolveElements.resolveElements(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal,
    };
    const cancel = () => gestureAbortController.abort();
    return [elements, eventOptions, cancel];
}

exports.setupGesture = setupGesture;
//# sourceMappingURL=setup.cjs.map
